import { z } from 'zod';
import { currencyCodeSchema, positiveDecimalSchema, uuidSchema } from './common';

export const goalAllocationRuleTypeSchema = z.enum([
  'fixed_amount',         // Her gelirden sabit X tutar
  'percentage_of_income', // Gelirin %X'i
]);
export type GoalAllocationRuleType = z.infer<typeof goalAllocationRuleTypeSchema>;

export const createGoalAllocationRuleSchema = z
  .object({
    ruleType: goalAllocationRuleTypeSchema,
    amount: positiveDecimalSchema.optional(),
    percent: z.coerce.number().min(0.01).max(100).optional(),
    priority: z.coerce.number().int().min(0).max(100).default(0),
    isActive: z.boolean().optional().default(true),
  })
  .refine(
    (d) =>
      (d.ruleType === 'fixed_amount' && d.amount !== undefined) ||
      (d.ruleType === 'percentage_of_income' && d.percent !== undefined),
    {
      message: 'fixed_amount → amount zorunlu, percentage_of_income → percent zorunlu',
    },
  );
export type CreateGoalAllocationRuleInput = z.infer<typeof createGoalAllocationRuleSchema>;

export const updateGoalAllocationRuleSchema = z.object({
  amount: positiveDecimalSchema.optional(),
  percent: z.coerce.number().min(0.01).max(100).optional(),
  priority: z.coerce.number().int().min(0).max(100).optional(),
  isActive: z.boolean().optional(),
});
export type UpdateGoalAllocationRuleInput = z.infer<typeof updateGoalAllocationRuleSchema>;

export const manualAllocateSchema = z.object({
  amount: positiveDecimalSchema,
  currency: currencyCodeSchema.default('EUR'),
  sourceTransactionId: uuidSchema.optional(),
  note: z.string().max(200).optional(),
});
export type ManualAllocateInput = z.infer<typeof manualAllocateSchema>;
